export const links = {
  facebook: 'https://www.facebook.com/fansipl-101999381631079',
  instagram: 'https://www.instagram.com/fansi.pl/',
  tiktok: 'https://www.tiktok.com/@homeofinfluencers?lang=pl-PL',
}
